<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" md="5">
        <v-card class="pa-2 card-radius">
          <v-card-title class="py-1 my-1">
            <span>Set your new password</span>
          </v-card-title>
          <v-card-text class="my-1 py-0">
            <v-container class="py-0 my-0">
              <v-row>
                <v-col cols="12" class="my-1 py-0">
                  <v-text-field 
                    v-model="newPassword"
                    :append-icon="showPassword1 ? 'visibility' : 'visibility_off'"
                    :type="showPassword1 ? 'text' : 'password'" 
                    :disabled="success" 
                    label="New password"
                    @click:append="showPassword1 = !showPassword1">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="my-1 py-0">
                  <v-text-field 
                    v-model="newPasswordRepeat" 
                    :append-icon="showPassword2 ? 'visibility' : 'visibility_off'"
                    :type="showPassword2 ? 'text' : 'password'"
                    :disabled="success" 
                    label="New password repeated"
                    @click:append="showPassword2 = !showPassword2">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-alert v-if="errorMessage" type="warning">
            {{errorMessage}}
          </v-alert>
          <v-alert v-if="tokenError" type="warning">
            Unfortunately, your forgotten password request has expired. Please <a href="/forgot-password" class="white--text">submit a new request</a>
          </v-alert>
          <v-alert v-if="defaultError" type="warning">
            Something isn't right. Please check your input and try again. Or  <a href="https://bit.ly/jeff_help" class="white--text">contact our support team.</a>
          </v-alert>
          <v-alert v-if="success" type="success">
            Password successfully set
          </v-alert>
          <v-card-actions class="pt-0 mt-0">
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="saving" :disabled="success" rounded @click="save()">Set new password</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { RESET_PASSWORD_MUTATION } from '../../constants/graphql/account/resetPassword'

  export default {
    name: 'ResetPassword',
    data() { 
      return {
        newPassword: '',
        newPasswordRepeat: '',
        saving: false,
        errorMessage: '',
        success: false,
        tokenError: false,
        defaultError: false,
        showPassword1: false,
        showPassword2: false,
      }
    },
    methods: {
      save() {
        this.$apollo.mutate({
          mutation: RESET_PASSWORD_MUTATION,
          variables: {
            token: this.$route.params.token, 
            newPassword1: this.newPassword, 
            newPassword2: this.newPasswordRepeat
          },
        }).then((response) => {
          if(response.data.passwordReset.success){
            this.success = true;
            setTimeout(() => {
              this.$router.push({ name: 'Login' })
            }, 4000)
          } else {
            let passwordErrors = response.data.passwordReset.errors;
            this.tokenError = false;
            this.defaultError = false;
            this.errorMessage = null;

            if (passwordErrors.nonFieldErrors && ["invalid_token", "expired_token"].includes(passwordErrors.nonFieldErrors[0].code)){
              this.tokenError = true;
            }
            else if (passwordErrors.newPassword2) {
              this.errorMessage = passwordErrors.newPassword2[0].message;
            }
            else {
              this.defaultError = true;
            }
          }
        }).catch((error) => {
          this.defaultError = true;
        })
      },
    },
  }
</script>
